import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useLang } from '../../../../language';
import { InputText } from '../../../../components/Inputs/InputText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { PersonasServices } from '../../controllers/services/personas.services';
import { ModalBuscarPersona } from '../../ModalBuscarPersona';
import { ModalStatusServer } from '../../../../components/ModalStatus/ModalStatusServer';

export const Personas = ({ setBreadcrumbLineItems, route }: any) => {

    const Lang = useLang()

    const { empresaId } = useParams()

    const [openModal, setOpenModal] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const [search, setSearch] = useState('')
    const [searchApplied, setSearchApplied] = useState('')

    const [fetchDisponiblesGET, fetchDisponiblesGETData] = PersonasServices.GET_DISPONIBLES()

    const [fetchSolicitarPOST, fetchSolicitarPOSTData] = PersonasServices.POST_SOLICITAR()

    const [fetchEliminarDELETE, fetchEliminarDELETEData] = PersonasServices.DELETE_PERSONA()

    // Persona que se está a punto de eliminar (se confirma en un Dialog)
    const [personaAEliminar, setPersonaAEliminar] = useState<any>(null)

    useEffect(() => {

        setBreadcrumbLineItems((item: any) => [...item.slice(0, 2), route])

    }, [])

    useEffect(() => {

        if (!empresaId) return

        // GET /integra-web/empresas/personas/disponibles
        fetchDisponiblesGET({
            params: {
                // El backend lee `page` (1-based), `per_page` y `search`
                empresa_id: Number(empresaId),
                page: page + 1,
                per_page: rowsPerPage,
                search: searchApplied || undefined,
            }
        })

    }, [page, rowsPerPage, refreshKey, searchApplied, empresaId])

    const handleInputSearch = (e: any) => {
        setSearch(e.target.value)
    }

    const handleBuscar = (e?: any) => {

        if (e) e.preventDefault()

        setSearchApplied(search.trim())
        setPage(0)
    }

    const handleLimpiar = () => {

        setSearch('')
        setSearchApplied('')
        setPage(0)
    }

    const handleChangePage = (event: any, newPage: number) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleAutorizar = (persona: any) => {

        if (!persona?.id) return

        // POST /integra-web/empresas/personas/solicitar
        fetchSolicitarPOST({
            body: {
                empresa_id: Number(empresaId),
                // La persona a la que se solicitan los datos es la seleccionada en el
                // buscador, no el usuario de la sesión: el backend no la deduce.
                usuario_id: Number(persona.id),
            }
        })
    }

    const handleEliminarPersona = (persona: any) => {

        setPersonaAEliminar(null)

        // DELETE /integra-web/empresas/personas/{id}
        fetchEliminarDELETE({ id: persona.id })
    }

    useEffect(() => {

        if (String(fetchSolicitarPOSTData.status)?.[0] === '2') {

            setOpenModal(false)
            setRefreshKey((key) => key + 1)
        }

    }, [fetchSolicitarPOSTData])

    useEffect(() => {

        if (String(fetchEliminarDELETEData.status)?.[0] === '2') {

            setPersonaAEliminar(null)
            setRefreshKey((key) => key + 1)
        }

    }, [fetchEliminarDELETEData])

    return (
        <div>

            <Paper className='p-3 p-md-4'>

                <Grid container spacing={2} alignItems='center' justifyContent='space-between'>

                    <Grid item xs={12} sm={7}>
                        <Typography variant='h6' className="my-0 fw-500 color-primary">
                            {Lang('PERSONAS')}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={5}>
                        <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}>
                            <Button
                                color="primary"
                                variant="contained"
                                size="medium"
                                startIcon={<FontAwesomeIcon icon={faUserPlus} />}
                                onClick={() => setOpenModal(true)}
                            >
                                {Lang('BUSCAR_AUTORIZAR_PERSONA')}
                            </Button>
                        </Box>
                    </Grid>

                </Grid>

                <Box
                    component="form"
                    onSubmit={handleBuscar}
                    className='mt-3'
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'stretch', sm: 'flex-end' },
                        gap: { xs: 1.5, sm: 1 },
                    }}
                >
                    <Box sx={{ flex: '1 1 300px' }}>
                        <InputText
                            label={Lang('BUSCAR_PERSONA')}
                            name='search'
                            value={search}
                            onChange={handleInputSearch}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            size="small"
                            disabled={fetchDisponiblesGETData.loading}
                        >
                            {Lang('REALIZAR_BUSQUEDA')}
                        </Button>

                        <Button
                            type="button"
                            color="primary"
                            variant="outlined"
                            size="small"
                            onClick={handleLimpiar}
                        >
                            {Lang('LIMPIAR')}
                        </Button>
                    </Box>
                </Box>

            </Paper>

            <Paper className='p-3 p-md-4 mt-3'>

                <Typography variant='h6' className="my-0 pb-1 fw-500 color-primary">
                    {Lang('LISTADO_PERSONAS')}
                </Typography>

                {
                    !fetchDisponiblesGETData.loading && fetchDisponiblesGETData.error &&
                    <Typography variant='caption' className='my-0 mt-2' sx={{ color: 'error.main', display: 'block', textAlign: 'center' }}>
                        {String(fetchDisponiblesGETData.error?.error || fetchDisponiblesGETData.error?.message || fetchDisponiblesGETData.error)}
                    </Typography>
                }

                <TableContainer className='mt-3'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{Lang('NOMBRE')}</TableCell>
                                <TableCell>{Lang('NIF')}</TableCell>
                                <TableCell>{Lang('EMAIL')}</TableCell>
                                <TableCell>{Lang('ESTADO')}</TableCell>
                                <TableCell align="right">{Lang('ACCIONES')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {
                                fetchDisponiblesGETData.loading &&

                                Array.from({ length: 5 }).map((_, index) => (
                                    <TableRow key={`skeleton-${index}`}>
                                        <TableCell><Skeleton variant="text" /></TableCell>
                                        <TableCell><Skeleton variant="text" /></TableCell>
                                        <TableCell><Skeleton variant="text" /></TableCell>
                                        <TableCell width={160}><Skeleton variant="rounded" height={32} /></TableCell>
                                        <TableCell align="right" width={90}><Skeleton variant="rounded" height={32} /></TableCell>
                                    </TableRow>
                                ))
                            }

                            {
                                fetchDisponiblesGETData.data?.items?.map((item: any) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.nombre}</TableCell>
                                        <TableCell>{item.nif}</TableCell>
                                        <TableCell>{item.email}</TableCell>
                                        <TableCell>
                                            {
                                                item.estado === 'autorizada' ?
                                                    <Chip
                                                        icon={<FontAwesomeIcon icon={faCheckCircle} />}
                                                        label={Lang('PERSONA_AUTORIZADA')}
                                                        color="success"
                                                    /> :
                                                    item.estado === 'rechazada' ?
                                                        <Chip
                                                            icon={<FontAwesomeIcon icon={faTimesCircle} />}
                                                            label={Lang('PERSONA_RECHAZADA')}
                                                            color="error"
                                                        /> :
                                                        item.estado === 'pendiente' ?
                                                            <Chip
                                                                label={Lang('PENDIENTE')}
                                                                color="warning"
                                                            /> :
                                                            <Chip
                                                                label={Lang('PERSONA_NO_AUTORIZADA')}
                                                            />
                                            }
                                        </TableCell>
                                        <TableCell align="right">
                                            <Button
                                                size="small"
                                                color="error"
                                                variant="outlined"
                                                startIcon={<FontAwesomeIcon icon={faTrash} />}
                                                onClick={() => setPersonaAEliminar(item)}
                                            >
                                                {Lang('ELIMINAR')}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }

                            {
                                !fetchDisponiblesGETData.loading && fetchDisponiblesGETData.data?.items?.length === 0 &&

                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <Box sx={{ textAlign: 'center', py: 5 }}>
                                            <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                                                {Lang('SIN_RESULTADOS')}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={fetchDisponiblesGETData.data?.numeroTotalElementos || 0}
                    page={fetchDisponiblesGETData.data?.numeroPagina || 0}
                    onPageChange={handleChangePage}
                    rowsPerPage={fetchDisponiblesGETData.data?.numeroElementos || rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={Lang('FILAS_POR_PAGINA')}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${Lang('DE')} ${count}`}
                />

            </Paper>

            <ModalBuscarPersona
                open={openModal}
                onClose={() => setOpenModal(false)}
                onAutorizar={handleAutorizar}
                empresaId={Number(empresaId)}
            />

            <ModalStatusServer
                fetchData={fetchSolicitarPOSTData}
                activeLoading
                messageStatus={
                    {
                        200:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchSolicitarPOSTData.data?.message || Lang('AUTORIZACION_SOLICITADA')}
                                </Typography>
                            </>,
                        201:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchSolicitarPOSTData.data?.message || Lang('AUTORIZACION_SOLICITADA')}
                                </Typography>
                            </>,
                    }
                }
            />

            <Dialog
                open={!!personaAEliminar}
                onClose={() => setPersonaAEliminar(null)}
            >
                <DialogTitle>
                    {Lang('ELIMINAR_PERSONA')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {Lang('ELIMINAR_PERSONA_CONFIRMACION')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setPersonaAEliminar(null)}>
                        {Lang('CANCELAR')}
                    </Button>
                    <Button
                        color="error"
                        variant="contained"
                        startIcon={<FontAwesomeIcon icon={faTrash} />}
                        onClick={() => handleEliminarPersona(personaAEliminar)}
                    >
                        {Lang('ELIMINAR')}
                    </Button>
                </DialogActions>
            </Dialog>

            <ModalStatusServer
                fetchData={fetchEliminarDELETEData}
                activeLoading
                messageStatus={
                    {
                        200:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchEliminarDELETEData.data?.message || Lang('PERSONA_ELIMINADA')}
                                </Typography>
                            </>,
                        201:
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className='color-green fa-2x' />

                                <Typography sx={{ mt: 2 }}>
                                    {fetchEliminarDELETEData.data?.message || Lang('PERSONA_ELIMINADA')}
                                </Typography>
                            </>,
                    }
                }
            />

        </div>
    )
}